import { render, staticRenderFns } from "./SubscribeMarket.vue?vue&type=template&id=8695ea82&"
import script from "./SubscribeMarket.vue?vue&type=script&lang=js&"
export * from "./SubscribeMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports